var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/12px/Status/Offline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#8F9CBD"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#8F9CBD"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 4,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusOffline);
export default __webpack_public_path__ + "static/media/status-offline.63236ed1382274af6f91b897551a6fc1.svg";
export { ForwardRef as ReactComponent };